/* Freccia "torna indietro" - Music Store Rovereto */
(function () {
  'use strict';

  function init() {
    var btn = document.getElementById('msr-back-btn');
    if (!btn) return;

    // Mostra il pulsante solo se c'e' una pagina precedente nella cronologia
    if (window.history.length > 1 && document.referrer !== '') {
      btn.classList.add('is-visible');
    }

    btn.addEventListener('click', function () {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = '/';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
